export default "__VITE_ASSET__CagWr4DS__"